import { styled } from 'styled-components'

export const StyledText = styled.div`
  min-height: 1em;
`
